// extracted by mini-css-extract-plugin
export default {"Lineadivisora":"WithTelefoniaMovil_Lineadivisora__NVGZr","Mensaje":"WithTelefoniaMovil_Mensaje__R62w5"};